module.exports = __webpack_public_path__ + "static/img/car.2ac5e456.jpg";